import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ThemeContext } from "../../context";
import Footer from "../Components/Footer";
import Menubar from "../Components/Menubar";
import Totop from "../Components/Totop";
import HealiaryPrivacy from "./HealiaryPrivacy";
import OstomyPrivacy from "./OstomyPrivacy";
import { DEFAULT_LANG } from "../../i18n";

const getLangFromPath = (pathname) => {
  const m = pathname.match(/^\/(kr|en)(\/|$)/);
  return m ? m[1] : DEFAULT_LANG;
};

export default function PrivacyPolicy() {
  const { theme } = useContext(ThemeContext);
  const { t } = useTranslation();
  const [slideIndex] = useState(0);
  const [tab, setTab] = useState(0);
  
  // Healiary, Ostomy txt:
  //  (N)   : new line
  //  (B)   : bold text
  //  (T-#) : table location
  //  (T-s) : special table location

  // set tab
  const onClick = (e, tabID) => {
    window.scrollTo(0, 0)
    setTab(tabID)
  }

  // // 모바일 메뉴
  // useEffect(() => {
  //   window.addEventListener("scroll", onScroll);
  //   return () => window.removeEventListener("scroll", onScroll);
  // }, [isScroll]);

  // Scroll Tracker
  const history = useHistory();
  const lang = getLangFromPath(history.location.pathname);
  const patharray = history.location.pathname.split("/")
  const submenu = patharray[patharray.length-2]
  const selected = submenu === "ostomy"
  // console.log(submenu)
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <div
      id="privacypolicy"
      style={{
        backgroundColor: theme === "dark" && "#282828",
        color: theme === "dark" ? "#fff" : "#282828",
      }}
    >
      <Menubar slideIndex={slideIndex} />
      <div
        className="TABS_sticky"
        style={{ backgroundColor: theme === "dark" && "#282828" }}
      >
        <div className="sticky_padding" />

        <div
          className={
            "TABS_layout TABS_layout_padding " +
            (theme === "dark"
              ? "menuBorderBottomDark"
              : "menuBorderBottomLight")
          }
        >
          <Link className="TABS_tab FontR textF16 no-decoration" onClick={e => onClick(e, 0)} to={`/${lang}/privacypolicy/healiary/0`} >
            <div
              className={
                selected === false
                  ? " w-full h-full tagADefault tabATagTab FontEB"
                  : "w-full h-full tagADefault FontR " +
                    (theme === "dark" ? "tcw" : "tcg3")
              }
            >
              {t("privacy.tabs.healiary")}
            </div>
          </Link>
          <div style={{ margin: "auto" }}>
            <div
              className="separator"
              style={{
                backgroundColor: theme === "dark" ? "#5F5F5F" : "#E1E1E1",
              }}
            />
          </div>
          <Link className="TABS_tab FontR textF16 no-decoration" onClick={e => onClick(e, 1)} to={`/${lang}/privacypolicy/ostomy/0`}>
            <div
              className={
                selected === true
                  ? "w-full h-full tagADefault tabATagTab FontEB"
                  : "w-full h-full tagADefault FontR " +
                    (theme === "dark" ? "tcw" : "tcg3")
              }
            >
              {t("privacy.tabs.ostomy")}
            </div>
          </Link>
        </div>
      </div>
      {selected === false
        ? <HealiaryPrivacy />
        : <OstomyPrivacy />
      }
      <Totop />
      <Footer />
    </div>
  );
}